import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CrmOffersWrapper from "@components/layouts/crmOffersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function InsureYourCarHome(): ReactElement {
    return (
        <CrmOffersWrapper>
            <PrivacyPolicy category="Crm" domain="CrmOffers.com" />
        </CrmOffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
